export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11189.eb36facc.jpg";